var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"ucFirst body-2",class:_vm.readOnly ? 'mb-2' : '',attrs:{"disabled":_vm.readOnly,"aria-label":_vm.formattedAriaLabel(
        _vm.metadata[("description" + (this.upperLocale))],
        _vm.required
    ),"label":_vm.formattedLabel(
        _vm.metadata[("description" + (this.upperLocale))],
        _vm.required
    ),"outlined":_vm.outlined,"append-icon":_vm.appendIcon,"value":_vm.value,"name":_vm.metadata.name,"color":_vm.$vuetify.theme.primary,"background-color":_vm.$vuetify.theme.primary,"placeholder":_vm.placeholder,"hint":_vm.readOnly ? _vm.formatHintText() : '',"persistent-hint":_vm.readOnly,"type":"number","min":_vm.minimumTraveler,"max":_vm.maximumTraveler,"rules":[
        !_vm.required || _vm.requiredField(),
        function (v) { return !v || v <= _vm.maximumTraveler || _vm.formatErrorText(); },
        function (v) { return !v || v >= _vm.minimumTraveler || _vm.formatErrorText(); }
    ],"data-meta-id":_vm.metadata.id,"id":_vm.metadata.name},on:{"input":_vm.debouncedInput}})}
var staticRenderFns = []

export { render, staticRenderFns }